<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.orderDetail')">
      <div class="right-header" v-if="visitInfo.isEdit" @click="toPage(`/storeMaintain/reOrderVisit?visitId=${visitInfo.id}&customerId=${visitInfo.customerId}`)">
        {{ $t('button.edit') }}
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info">
        <span class="customer-name">{{ visitInfo.customerName }}</span>
        <span class="tag-info" :class="visitInfo.customerTag | formatTagClass" v-if="!['', null].includes(visitInfo.customerTag)">{{ visitInfo.customerTag | formatTag }}</span>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.visitInfo') }}.</div>
        <div class="item-info">
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.name') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.createUserName }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.visitDate') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.visitTime }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.checkInPhoto') }}</span>
            <span class="right" v-if="visitInfo.imgMap && visitInfo.imgMap.check">
              <img v-for="(subItem, subIndex) in visitInfo.imgMap.check.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.check)">
            </span>
          </div>
        </div>
      </div>
      <div class="info" v-if="checkPer(['admin', 'app:reorder:direct']) && visitInfo.po && visitInfo.po.isDirect">
        <div class="item-title">{{ $t('form.sellInFromAcmefog') }}</div>
        <div class="item-info" v-if="visitInfo.po">
          <div class="is-Direct">
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                <div style="color: #317bff;">{{ $t('form.quantitySoldPcs') }}</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font">{{ totalProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.po.productList" :key="brandIndex">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <div class="section-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font">{{ brandItem.totalSpec }}</span> {{ $t('form.pcs') }}</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
            <div class="top-title">
              <div class="right-title">
                <img class="ell-icon" src="@/assets/images/ell_custom_icon.png" alt="">
                <div style="color: #808000">{{ $t('form.quantityGivenAwayPcs') }}</div>
              </div>
              <div>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000">{{ totalGiveProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div v-for="(brandItem, brandIndex) in visitInfo.po.giveProductList" :key="brandIndex + '1'">
              <div class="custom-section section-quantity" v-if="brandItem.totalSpec > 0">
                <div class="section-title custom-section-title square">
                  <span style="flex: 1;">{{ brandItem.projectName }}</span>
                  <span>{{ $t('form.total') }}：<span class="custom-font" style="color: #808000">{{ brandItem.totalSpec }}</span> Pcs</span>
                </div>
                <van-collapse v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" v-model="subItem.activeNames" :class="{'custom-collapse': !subItem.activeNames.includes('1')}">
                  <van-collapse-item title="" name="1">
                    <template #title>
                      <div class="collapse-title">
                        <img class="jt-icon" src="@/assets/images/jt_custom_icon.png" alt="">
                        <span>{{ subItem.productName }}：</span>
                        <span><span class="custom-font" style="color: #808000">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</span>
                      </div>
                    </template>
                    <div class="spec-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                      <div class="quantity-item custom-quantity-item">
                        {{ specItem.specName }}：<span>{{ specItem.quantity }}</span>
                      </div>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </div>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.paymentType') }}</span>
            <span class="right custom-font txt-ellipsis">{{ visitInfo.po.paymentType }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.paymentStatus') }}</span>
            <span class="right custom-font txt-ellipsis">{{ visitInfo.po.paymentStatus }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.tax') }}</span>
            <span class="right custom-font txt-ellipsis">{{ visitInfo.po.taxType }}</span>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && (visitInfo.imgMap.directPoOrder || visitInfo.imgMap.directReceipt || visitInfo.imgMap.directProductCashOrCheque)">
            <div class="left img-left txt-ellipsis section-title square">{{ $t('form.sellInPhoto') }}</div>
            <div class="sell-in-photo">
              <!-- <img v-for="(subItem, subIndex) in visitInfo.imgMap.servicePhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt=""> -->
              <div class="photo-item" v-if="visitInfo.imgMap.directPoOrder">
                <span class="item-left">{{ $t('form.pOOrder') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.directPoOrder.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.directPoOrder)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.directReceipt">
                <span class="item-left">{{ $t('form.receipt') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.directReceipt.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.directReceipt)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.directProductCashOrCheque">
                <span class="item-left">{{ $t('form.productCashCheque') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.directProductCashOrCheque.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.directProductCashOrCheque)">
                </span>
              </div>
            </div>
          </div>
          <div v-if="historyList.length > 0" class="custom-section">
            <div class="section-title square">
              <span style="flex: 1;">{{ $t('form.orderModificationHistory') }}</span>
              <span class="total-desc" @click="toPage(`/shared/orderUpdate?sourceId=${paramsUrl.visitId}&sourceType=0&moduleType=1`)">More ></span>
            </div>
            <div class="history-info">
              <div class="time-name">{{ historyList[0].localCreateTime }} {{ historyList[0].createUserName }}</div>
              <div class="reason-info">
                <span class="reason-text">{{ $t('form.editReason') }}：</span>
                <span>{{ historyList[0].remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="isShowReorderList || (visitInfo.isSellInBa && visitInfo.imgMap && (visitInfo.imgMap.poOrder || visitInfo.imgMap.receipt || visitInfo.imgMap.productCashOrCheque))">
        <div class="item-title">{{ $t('form.sellInFromDistributor') }}</div>
        <div class="item-info">
          <div class="custom-section" v-for="(brandItem, brandIndex) in visitInfo.reorderList" :key="brandIndex">
            <div class="section-title square">
              <span style="flex: 1;">{{ brandItem.projectName }}</span>
              <span>{{ $t('form.total') }}：<span class="custom-font">{{ allProdctPcs(brandItem, 'reorderList') }}</span> {{ $t('form.pcs') }}</span>
            </div>
            <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="product-item">
                <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                <div>{{ subItem.productName }}：<span class="pcs-num">{{ calculateNum(subItem.quantity, subItem.giveQuantity) }} </span>{{ $t('form.pcs') }}</div>
              </div>
              <div class="section-product-sell">
                <div class="sell-in-item">
                  <div class="quantity-item">
                    {{ $t('form.quantitySoldPcs') }}：<span>{{ subItem.quantity ? subItem.quantity : 'Unknown' }}</span>
                  </div>
                  <div class="quantity-item">
                    {{ $t('form.quantityGivenAwayPcs') }}：<span>{{ subItem.giveQuantity ? subItem.giveQuantity : 'Unknown' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <div class="product-item">
                <img class="sd-icon" src="@/assets/images/ell_sd.png" alt="">
                <div>{{ $t('form.brandSupplierDistributor') }}</div>
              </div>
              <div class="section-product-sell">
                <div class="sell-in-item">
                  <div class="quantity-item" v-for="(sdItem, sdIndex) in brandItem.expandInfo.sdList" :key="sdIndex">
                    {{ sdItem.sdName }}
                  </div>
                  <div class="quantity-item" v-if="brandItem.expandInfo.otherSd">
                    {{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="custom-section" v-if="visitInfo.isSellInBa && visitInfo.imgMap && (visitInfo.imgMap.poOrder || visitInfo.imgMap.receipt || visitInfo.imgMap.productCashOrCheque)">
            <div class="left img-left txt-ellipsis section-title square">{{ $t('form.sellInPhoto') }}</div>
            <div class="sell-in-photo">
              <!-- <img v-for="(subItem, subIndex) in visitInfo.imgMap.servicePhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt=""> -->
              <div class="photo-item" v-if="visitInfo.imgMap.poOrder">
                <span class="item-left">{{ $t('form.pOOrder') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.poOrder.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.poOrder)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.receipt">
                <span class="item-left">{{ $t('form.receipt') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.receipt.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.receipt)">
                </span>
              </div>
              <div class="photo-item" v-if="visitInfo.imgMap.productCashOrCheque">
                <span class="item-left">{{ $t('form.productCashCheque') }}</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.productCashOrCheque.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.productCashOrCheque)">
                </span>
              </div>
            </div>
          </div>
          <div v-if="distrHistoryList.length > 0" class="custom-section">
            <div class="section-title square">
              <span style="flex: 1;">{{ $t('form.orderModificationHistory') }}</span>
              <span class="total-desc" @click="toPage(`/shared/orderUpdate?sourceId=${paramsUrl.visitId}&sourceType=0&moduleType=2`)">More ></span>
            </div>
            <div class="history-info">
              <div class="time-name">{{ distrHistoryList[0].localCreateTime }} {{ distrHistoryList[0].createUserName }}</div>
              <div class="reason-info">
                <span class="reason-text">{{ $t('form.editReason') }}：</span>
                <span>{{ distrHistoryList[0].remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="sampleListTotal > 0 || materialListTotal > 0">
        <div class="item-title">{{ $t('form.materialSampleDelivery') }}</div>
        <div class="item-info is-Direct" v-if="sampleListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.sampleDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ sampleListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="sampleList.length > 0">
            <div class="material-item" v-for="subItem in sampleList" :key="subItem.id">
              {{ subItem.projectName }}·{{ subItem.productName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="item-info is-Direct" v-if="materialListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.materialDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ materialListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey">
            <div class="material-item" v-for="subItem in putMaterielList" :key="subItem.id">
              {{ subItem.materielName }}：{{ subItem.quantity }}
            </div>
          </div>
          <div class="custom-section img-content" v-if="visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto">
            <div class="img-imgMap-left">{{ $t('form.materialSamplePhoto') }}</div>
            <div class="img-right">
              <img v-for="(subItem, subIndex) in visitInfo.imgMap.deliveryMaterialProto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.deliveryMaterialProto)">
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.feedback">
        <div class="item-title">{{ $t('shared.feedback') }}</div>
        <div class="item-info">
          <div class="item-section">
            {{ visitInfo.feedback }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arsVisitInfoApi } from '@/api/visit'
import { changeListPageApi } from '@/api/shared'
import { ImagePreview, Toast } from 'vant'
import { mapState } from 'vuex'
import { calculateAdd } from '@/utils/math'
import i18n from '@/i18n'
export default {
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      activeNames: [],
      paramsUrl: {},
      customerInfo: {},
      decisionContact: {},
      retailList: [],
      visitInfo: {},
      putMaterielList: [],
      sampleList: [],
      historyList: [],
      distrHistoryList: []
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getVisitInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    materialListTotal () {
      return this.putMaterielList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    totalProductQuantity () {
      if (!this.visitInfo.po || !this.visitInfo.po.productList) {
        return 0
      }
      return this.visitInfo.po.productList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    totalGiveProductQuantity () {
      if (!this.visitInfo.po || !this.visitInfo.po.giveProductList) {
        return 0
      }
      return this.visitInfo.po.giveProductList.reduce((acc, curr) => acc + Number(curr.totalSpec), 0)
    },
    isShowReorderList () {
      if (!this.visitInfo.reorderList || this.visitInfo.reorderList.length === 0) {
        return false
      }
      return this.visitInfo.reorderList.some(brandItem => {
        return brandItem.productList.length > 0
      })
    }
  },
  methods: {
    getVisitInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsVisitInfoApi(this.paramsUrl.visitId).then(res => {
        Toast.clear()
        const { po, putMaterielList, protoList, reorderList } = res.data
        po.productList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        po.giveProductList.forEach(brandItem => {
          let totalSpec = 0
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
            subItem.specList = subItem.specList.filter(specItem => {
              return !['', null].includes(specItem.quantity)
            })
            totalSpec += subItem.specList.reduce((sum, specItem) => {
              return sum + (specItem.quantity ? Number(specItem.quantity) : 0)
            }, 0)
          })
          brandItem.totalSpec = totalSpec
        })
        this.putMaterielList = putMaterielList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.sampleList = protoList.filter(subItem => {
          return subItem.quantity > 0
        })
        reorderList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        this.visitInfo = res.data
        const data = {
          sourceId: this.paramsUrl.visitId,
          sourceType: 0,
          moduleType: 1
        }
        changeListPageApi(data).then(res => {
          this.historyList = res.data.list
        })
        changeListPageApi({ ...data, moduleType: 2 }).then(res => {
          this.distrHistoryList = res.data.list
        })
      })
    },
    imgPreview (index, url) {
      ImagePreview({
        images: url.split(','),
        startPosition: index
      })
    },
    getlocation (params) {
      const currentTimeLoc = JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url) {
      if (!url) {
        Toast(this.$t('tips.stayTuned'))
        return
      }
      this.$router.push(url)
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    },
    allProdctPcs (params = {}) {
      if (params.productList.length > 0) {
        return params.productList.reduce((acc, curr) => acc + this.calculateNum(curr.quantity, curr.giveQuantity), 0)
      }
      return 0
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    font-size: 14px;
    color: #307bff;
  }
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    .customer-name {
      text-align: center;
      word-break: break-word;
    }
    >span {
      font-size: 14px;
    }
    >span:nth-child(2) {
      margin-top: 5px;
    }
    .center-btn {
      padding: 2px 5px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: 400;
      font-size: 12px;
    }
  }
  .tag-info {
    padding: 3px 5px;
    text-align: center;
    font-size: 10px;
    border: 1px solid #ee541b;
    color: #ee541b;
    background-color: #eccfc4;
    margin-right: 6px;
  }
  .tag0 {
    border: 1px solid #0db00b;
    color: #0db00b;
    background-color: #abdaaa;
  }
  .tag2 {
    border: 1px solid #dc851f;
    color: #dc851f;
    background-color: #f0e2d1;
  }
  .tag3 {
    border: 1px solid #7f7f7f;
    color: #7f7f7f;
    background-color: #dcdcdc;
  }
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .item-info {
      padding: 0px 12px;
      .top-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #333;
        font-size: 12px;
        margin-top: 10px;
        .right-title {
          display: flex;
          align-items: center;
        }
        .ell-icon {
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 200px;
        }
        .right {
          flex: 1;
          text-align: right;
        }
        .img-left {
          width: 126px;
        }
        .img-right {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
      }
      .photo-img {
        width: 60px;
        height: 60px;
        margin-right: 5px;
        margin-bottom: 5px;
      }
      .custom-section {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        &:last-child {
          border-bottom: none;
        }
        .img-left {
          width: 126px;
        }
        .img-right {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
        }
        .section-product-sell {
          padding: 10px;
          background-color: #f7f7f7;
          margin-top: 8px;
          border-radius: 8px;
          .sell-in-item {
            margin-bottom: 8px;
            color: #7f7f7f;
            &:last-child {
              margin-bottom: 0;
            }
            .quantity-item {
              margin-bottom: 6px;
              &:last-child {
                margin-bottom: 0;
              }
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
        }
        .product-item {
          display: flex;
          align-items: center;
          padding-top: 10px;
        }
        .history-info {
          padding: 10px;
          margin-top: 8px;
          border-radius: 8px;
          background-color: #f7f7f7;
          color: #333;
          .time-name {
            margin-bottom: 6px;
          }
          .reason-info {
            word-break: break-word;
          }
          .reason-text {
            color: #307bff;
            font-weight: bold;
          }
        }
      }
      .section-quantity {
        padding-left: 5px;
      }
      .img-content {
        margin: 10px 0;
        border-top: 2px solid #e8effc;
        border-bottom: 2px solid #e8effc !important;
      }
      .sell-in-photo {
        .photo-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 12px;
          border-bottom: 1px solid #e8effc;
          .item-left {
            width: 126px;
          }
          .item-right {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
          }
        }
      }
      .section-title,
      .product-title {
        display: flex;
        align-items: center;
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .total-desc {
          font-weight: 400;
        }
      }
      .custom-section-title {
        &.square {
          &::before {
            background-color: #808000;
          }
        }
      }
      .product-title {
        padding-top: 10px;
        color: #333;
        .left-desc {
          flex: 1;
          font-weight: bold;
        }
      }
      .is-Direct {
        .section-product-sell {
          margin-top: 0px !important;
        }
        .custom-section {
          padding-bottom: 5px;
          border-bottom: none;
        }
        .spec-item {
          margin-bottom: 8px;
          color: #7f7f7f;
          &:last-child {
            margin-bottom: 0;
          }
          .quantity-item {
            margin-bottom: 6px;
            &:last-child {
              margin-bottom: 0;
            }
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
          .custom-quantity-item {
            &::before {
              color: #808000;
            }
          }
        }
        .collapse-title {
          display: flex;
          align-items: center;
          padding: 5px 0px;
        }
        /deep/.van-collapse {
          .van-collapse-item__title {
            padding: 0;
            font-size: 12px;
            margin-bottom: 0;
          }
          .van-collapse-item__title--expanded::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 10px;
            font-size: 12px;
            background-color: #f7f7f7;
            border-radius: 10px;
          }
          .van-cell__right-icon {
            right: 10px;
            top: 5px;
          }
        }
        /deep/.van-hairline--top-bottom::after {
          display: none;
        }
        .custom-collapse {
          /deep/.van-collapse-item__title {
            border-radius: 10px;
          }
        }
      }
    }
    .material-delivey {
      padding: 10px;
      background-color: #f7f7f7;
      margin-top: 8px;
      border-radius: 8px;
      color: #7f7f7f;
      .material-item {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
        &::before {
          content: '#';
          width: 8px;
          height: 8px;
          color: #307bff;
          margin-right: 5px;
        }
      }
    }
    .custom-font {
      font-weight: bold;
      color: #307bff;
    }
    .jt-icon {
      width: 9px;
      height: 12px;
      margin-right: 5px;
    }
    .sd-icon {
      width: 10px;
      height: 9px;
      margin-right: 5px;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
}
</style>
